import React from 'react';
const DocumentManagement = () => {
  return (
    <div className="p-6">
      <h1 className="font-serif font-bold text-3xl text-primary mb-6">Document Management</h1>
      <div className="bg-card p-8 rounded-xl shadow-card">
        <p className="text-muted-foreground">Manage documents</p>
      </div>
    </div>
  );
};
export default DocumentManagement;